import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useQueryParams = () => {
  const location = useLocation();

  return useMemo(() => {
    const withQueryParams = (path: string, params?: Record<string, string | number | boolean | undefined>): string => {
      const searchParams = new URLSearchParams(location.search);
      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined) {
            searchParams.set(key, String(value));
          }
        });
      }
      const urlParamString = Array.from(searchParams.keys()).length ? `?${searchParams.toString()}` : "";
      return `${path}${urlParamString}`;
    };
    return withQueryParams;
  }, [location.search]);
};